import React, {useEffect, useState} from 'react';
import {useLookups} from '../context/LookupContext';
import api from '../api/api';

export default function CoverLetter({ isOpen, onClose, onSave, initialDate, jobTrackerId }) {
  const { lookups, loading: lookupsLoading } = useLookups();
const starterCoverLetter = `Andrew Clark
123-456-7890
example@gmail.com

Dear TechCorp Industries,



Sincerely,
Andrew Clark`;

  const [formData, setFormData] = useState({
    Title: '',
    Description: '',
    Date: '',
    Text: starterCoverLetter,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!lookupsLoading && lookups.focusAreas.length > 0 && !formData.FocusAreaID) {
      setFormData(prev => ({ ...prev, FocusAreaID: lookups.focusAreas[0].id }));
    }
  }, [lookupsLoading, lookups.focusAreas, formData.FocusAreaID]);

  // When the modal opens, load any previously saved cover letter for this job
  // (so editing starts from the saved content instead of the blank template),
  // and apply the selected date if one was passed in.
  useEffect(() => {
    if (!isOpen) return;
    let cancelled = false;
    const formattedDate = initialDate ? new Date(initialDate).toISOString().slice(0, 16) : '';

    // Clear out whatever was left from the previously viewed letter so it
    // doesn't flash on screen while this job's letter is still loading.
    setFormData({ Title: '', Description: '', Date: formattedDate, Text: '' });

    if (jobTrackerId) {
      api.get(`/jobs/tracker/${jobTrackerId}/cover-letter`)
        .then((res) => {
          if (cancelled) return;
          const data = res.data || {};
          setFormData({
            Title: data.title || '',
            Description: data.description || '',
            Date: formattedDate,
            Text: data.text || starterCoverLetter,
          });
        })
        .catch(() => {
          if (cancelled) return;
          setFormData({ Title: '', Description: '', Date: formattedDate, Text: starterCoverLetter });
        });
    } else {
      setFormData({ Title: '', Description: '', Date: formattedDate, Text: starterCoverLetter });
    }

    return () => { cancelled = true; };
  }, [isOpen, initialDate, jobTrackerId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      if (onSave) {
        await onSave({
          text: formData.Text,
          date: formData.Date || null,
          title: formData.Title || null,
          description: formData.Description || null,
        });
      } else {
        onClose();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save cover letter');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
      <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-[1000] p-4">
        <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full mt-16 max-h-[80vh] overflow-y-auto">
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <h2 className="text-xl font-bold text-black">Cover Letter</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
          </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
            {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">{error}</div>}

          <div>
            <textarea
              name="Text"
              value={formData.Text}
              onChange={handleInputChange}
              rows={12}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-black whitespace-pre-wrap"
              placeholder="Enter cover letter text"
              required
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 text-black bg-gray-100 rounded-lg">Cancel</button>
            <button type="submit" disabled={isSubmitting} className="flex-1 px-4 py-2 bg-primary-600 text-white rounded-lg disabled:opacity-50">
              {isSubmitting ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}